<template>
  <div>
    <top-bar :user="user" />
    <MenuItems :user="this.user" :menuSelected="{ profile: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ profile: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true,
      }">
        <div>
          <div class="left">
            <h1>{{ $t("profileName") }}</h1>
            <p>{{ $t("profileMessage") }}</p>
          </div>
          <div class="right" v-if="this.isUserPremium(user)">
            <a class="notification-action custom-notification-action" href="/add_offer">{{ $t("addOfferLabel") }}</a>
          </div>
        </div>
        <br clear="all" />

        <div class="addOfferLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <div class="container-alb">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-3 d-flex justify-content-center">
                  <div class="uploadImageDiv">
                    <div v-if="this.previewImage" class="offer-preview-image"
                      :style="{ 'background-image': `url(${previewImage})` }"></div>

                    <img v-else class="membership-user border-round" :src="
                      this.getImagePath() +
                      'users/user_' +
                      user.person.id +
                      '.png'
                    " @error="($event.target.src = require('@/assets/images/offer_0.svg'))" />
                    <!-- <div
                            v-else
                            class="offer-preview-image"
                            :style="{
                              'background-image': `url(${previewImage})`,
                            }"
                          ></div> -->

                    <br />
                    <a @click="$refs.fileInput1.click()" class="uploadFile">
                      {{ $t("changeImageLabel") }}</a>
                    <input type="file" @input="uploadFile()" ref="fileInput1" style="display: none"
                      accept=".png, .jpg, .jpeg" />
                    <br />
                    <br />
                    <div v-if="this.isUserPremium(user)">
                      <img :src="require('@/assets/images/memberCrown.svg')" />
                    </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-sm-6 mb-3">
                      <small>{{ $t("lastNameLabel") }}</small>
                      <br />
                      <input type="text" disabled v-model="user.person.last_name" class="formedituser" />
                    </div>
                    <div class="col-sm-6 mb-3">
                      <small>{{ $t("firstNameLabel") }}</small>
                      <br />
                      <input type="text" disabled v-model="user.person.first_name" class="formedituser" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mb-3">
                      <small>{{ $t("companyLabel") }}</small>
                      <br />
                      <input type="text" disabled v-model="user.companies[0].name" class="formedituser" />
                    </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6 mb-3">
                        <small>{{ $t("mobilePhoneLabel") }}</small>
                        <br/>
                        <input type="text" class="formedituser" v-model="user.person.mobile_phone"
                          :style="validateMobileClass" required />
                      </div>
                      <div class="col-sm-6 mb-3">
                        <small>{{ $t("emailLabel") }}</small>
                        <br />
                        <input type="text" class="formedituser" v-model="user.person.email" :style="validateEmailClass"
                          required disabled />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6 mb-3">
                        <small>{{ $t("websiteLabel") }}</small>
                        <br />
                        <input v-if="isUserAdmin(user)" type="text" v-model="user.person.website"
                          class="formedituser" />
                        <input v-else type="text" v-model="user.person.website" disabled class="formedituser" />
                      </div>
                      <div class="col-sm-6 mb-3">
                        <small>{{ $t("roleCompanyLabel") }}</small>
                        <br />
                        <input type="text" v-model="user.person.function" class="formedituser" maxlength="64" />
                        <!-- <select v-model="user.person.functionId" class="w-100">
                          <option v-for="(entry, index) in functions" :key="index" :value="entry.code">
                            {{ entry.name }}
                          </option>
                        </select> -->
                        <!-- <input type="text" v-model="user.person.function" class="formedituser" /> -->
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6 mb-3">
                        <small>{{ $t("cityLabel") }}</small>
                        <multiselect
                              v-model="user.person.city"
                              :options="cities"
                              class="margin-top-1rem"
                              :placeholder="$t('selectLabel')"
                              select-label=""
                              selected-label=""
                              deselect-label=""
                            />
                      </div>
                      <div class="col-sm-6 mb-3">
                        <small>{{ $t("companyCityLabel") }}</small>
                        <multiselect v-if="isUserAdmin(user)" 
                              v-model="user.person.company_city"
                              :options="cities"
                              class="margin-top-1rem"
                              :placeholder="$t('selectLabel')"
                              select-label=""
                              selected-label=""
                              deselect-label=""
                            />
                        <input type="text" v-else v-model="user.person.company_city" disabled class="formedituser" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 mb-3">
                        <small>{{ $t("companyDescriptionLabel") }}</small>
                        <textarea v-if="isUserAdmin(user)"  class="formedituser w-100" maxlength="500" v-model="user.person.company_description" />
                        <input v-else type="text" v-model="user.person.company_description" disabled class="formedituser" />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-sm-6 mb-3">
                        <div>
                          <small>{{ $t("openBussinessLabel") }}</small>
                          <div class="custom-control custom-switch">
                            <input type="checkbox" id="customSwitchN" class="custom-control-input"
                              :checked="user.person.open_bussiness" @click="
                                user.person.open_bussiness =
                                !user.person.open_bussiness
                              " />
                            <label class="custom-control-label" for="customSwitchN"></label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-3">
                        <div v-if="user.person.open_bussiness" class="contact-details-wrapper" style="max-width: 100px">
                          <a @click="user.person.whatsapp = !user.person.whatsapp">
                            <img class="contact-button" :class="!user.person.whatsapp && 'opacity50'"
                              src="@/assets/images/whatsapp.svg" />
                          </a>
                          <a @click="user.person.phone_flag = !user.person.phone_flag">
                            <img class="contact-button" :class="!user.person.phone_flag && 'opacity50'"
                              src="@/assets/images/phone.svg" />
                          </a>
                          <a @click="user.person.email_flag = !user.person.email_flag">
                            <img class="contact-button" :class="!user.person.email_flag && 'opacity50'"
                              src="@/assets/images/mail.svg" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-sm-6 mb-3">
                        <a class="button-all button-orange" @click="submitDetails()">{{
                          $t("saveChangesLabel")
                        }}</a>&nbsp;&nbsp;&nbsp;&nbsp;
                      </div>
                      <div class="col-sm-6 mb-3">
                        <a class="resetButton culoare-11" @click="showModalPopup('modal_popup_actionRequest', true)">{{
                          $t("deleteAccountLabel")
                        }}</a>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="margin-left-25">
            <div class="container-alb padding-15 home-wrapper">
              <h5>{{ $t("askQuestionTitle") }}</h5>
              <p>{{ $t("askQuestionLabel") }}</p>
              <br />

              <a class="button-all button-black" @click="showModalPopup('modal_popup_question', true)">{{
                $t("askQuestionButton")
              }}</a>
            </div>

            <div v-if="this.isUserPremium(user) || this.isUserAdmin(user)"
              class="container-alb padding-15 home-wrapper scroll-window">
              <table>
                <tr>
                  <td>
                    <h5>{{ $t("newsTitle") }}</h5>
                  </td>
                  <td>
                    <!-- @click="seeAllNews()" -->
                    <a class="culoare-11 resetButton" target="_blank"
                      href="https://companie.upromania.ro/media/ultimele-noutati/">{{
                        $t("seeAllButton")
                      }}</a>
                  </td>
                </tr>
                <tr v-for="(entry, index) in news" :key="index">
                  <td colspan="2">
                    <p class="news-date">
                      {{ entry.date }}
                    </p>
                    <a class="resetButton" :href="entry.link" target="_blank">
                      {{ entry.title }}
                    </a>
                    <br />
                  </td>
                </tr>
              </table>
            </div>
            <div v-else class="container-alb padding-15 home-wrapper" :style="{
              background:
                'url(' +
                require('@/assets/images/home/image1.png') +
                ') no-repeat center left ',
            }">
              <h5>{{ $t("membershipTitle") }}</h5>
              <p>{{ $t("membershipProfileText") }}</p>
              <br />

              <a class="button-all button-white" href="/membership">{{
                $t("textButtonDiscover")
              }}</a>
            </div>
          </div>
          <!-- <offer-case
                  :offer="newOffer"
                  :image="previewImage"
                  :isDiscount="isDiscount"
                  :discountValue="discountValue"
                  :currency="newOffer.currency"
                  @showDetails="openOfferDetails"
                /> -->
        </div>
      </div>
    </div>
    <!-- <modal-loading /> -->
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.userError">
          <p v-html="$t('error_' + this.userError.code)"></p>
        </div>
        <div v-else-if="this.sendQuestionSuccess === true">
          <p>{{ $t("askQuestionSuccessMessage") }}</p>
        </div>
        <div v-else>
          <p>{{ $t("personModifySuccess") }}</p>
        </div>
      </div>
    </div>
    <div id="modal_popup_actionRequest" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_actionRequest', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div class="padding-50">
          <img src="@/assets/images/emoticon_inchidere_cont.svg" />

          <h1>{{ $t('confirmDeleteAccount') }}</h1>
          <p v-html="$t('confirmDeleteAccountText')"></p>
          <br />
          <a class="button-black button-padding" @click="showModalPopup('modal_popup_actionRequest', false)">{{
            $t("confirmDeleteAccountCancel")
          }}</a>
          <a class="button-white button-padding" @click="deleteAccount()">{{
            $t("confirmDeleteAccountConfirm")
          }}</a>
        </div>
      </div>
    </div>
    <div id="modal_popup_question" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_question', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div class="padding-50">
          <div>
            <div>
              <h1>{{ $t("askQuestionTitle") }}</h1>
              <p>{{ $t("askQuestionLabel") }}</p>
            </div>
          </div>
          <br clear="all" />
          <table width="95%" cellspacing="0">
            <tr>
              <td align="top" rowspan="2" width="200px">
                <img class=" border-round" :src="require('@/assets/images/question.svg')" />
              </td>
              <td align="left">
                <small class="bold">{{ $t('questionTitle') }}</small>
                <textarea required v-model="message" class="formedituser" maxlength="1000" />
              </td>
            </tr>

            <tr>
              <td>
                <a class="button-all button-orange" @click="submitQuestion()">{{
                  $t("sendButtonLabel")
                }}</a>&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "../components/company/TopBar.vue";
import MenuItems from "../components/company/MenuItems.vue";
import validator from "@/plugins/fieldValidation";
// import ModalLoading from "../components/fragments/ModalLoading.vue";
import news from "@/assets/json/news.js";
import httpServiceCustomer from "@/http/http-customer.js";
import cities from "@/assets/json/orase.js";


export default {
  name: "Profile",
  components: { TopBar, MenuItems, 
    // ModalLoading 
  },
  data() {
    return {
      user: null,
      news: news,
      userError: null,
      previewImage: null,
      sendQuestionSuccess: false,
      message: "",
      functions: [{
        code: 4,
        name: "Sales manager"
      }],
      cities: cities,
    };
  },
  methods: {
    submitDetails() {
      // this.showModalPopup("modal_popup_loading", true);
      httpServiceCustomer.customerService
        .updatePersonInfo(this.user.id, this.user.person, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.userError = { code: error.response.code };
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .then((response) => {
          if (response.status == 200) {
            this.userError = null;
            this.sendQuestionSuccess = false;
            Cookies.remove("user_data");
            this.getUser();
            //  this.user = this.getUser();
          } else {
            this.userError = {
              code: response.data.code,
              description: "Error adding offer",
            };
          }
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    seeAllNews() {
      this.userError = {
        code: "NOT_IMPLEMENTED",
      };
      this.showModalPopup("modal_popup_info", true);
    },
    deleteAccount() {
      this.showModalPopup("modal_popup_actionRequest", false);
      // this.showModalPopup("modal_popup_loading", true);
      httpServiceCustomer.customerService
        .deleteUser(this.user, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.userError = { code: error.response.code };
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .then((response) => {
          if (response.status == 200) {
            this.userError = null;
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
            this.logout();
          } else {
            this.userError = {
              code: response.data.code,
              description: "Error adding offer",
            };
          }
        });
    },
    submitQuestion() {
      // this.showModalPopup("modal_popup_loading", true);
      let formData = {
        code: this.user.id,
        description: this.message,
      };
      httpServiceCustomer.customerService
        .sendFeedbackMail(formData, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.message = "";
            this.sendQuestionSuccess = true;

          } else if (
            response.status == 400 ||
            response.status == 403 ||
            response.status == 404
          ) {
            this.userError = response.response;
          }
          this.showModalPopup('modal_popup_question', false)
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          this.error = {
            code: error.response.status,
          };
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    logout() {
      Cookies.remove("user_data");
      Cookies.remove("token");
      this.$router.push({
        name: "login",
      });
    },
    uploadFile() {
      let input = this.$refs.fileInput1;
      let file = input.files;
      if (file && file[0]) {
        let readerOffer = new FileReader();
        readerOffer.onload = (e) => {
          if (!e) {
            this.user.person.image = btoa(readerOffer.content);
          } else {
            this.user.person.image = btoa(e.target.result);
          }
        };
        // reader.readAsDataURL(file[0]);
        if (readerOffer.readAsBinaryString) {
          readerOffer.readAsBinaryString(file[0]);
        } else {
          alert("This browser does not support HTML5.");
        }

        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        if (reader.readAsBinaryString) {
        } else {
          alert("This browser does not support HTML5.");
        }
        // this.$emit("input", file[0]);
      }
    },
    askQuestion() {
      this.newOfferError = {
        code: "NOT_IMPLEMENTED",
      };
      this.showModalPopup("modal_popup_info", true);
    },
  },
  created() {
    this.user = this.getUser();
  },
  computed: {
    validateEmailClass() {
      return this.user.person.email === ""
        ? ""
        : validator.validateEmail(this.user.person.email)
          ? ""
          : "outline-color: #ff0000a6; ";
    },
    validateMobileClass() {
      return this.user.person.mobile_phone === ""
        ? ""
        : validator.validateMobilePhone(this.user.person.mobile_phone)
          ? ""
          : "outline-color: #ff0000a6; ";
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />

<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.textarea {
  margin: 0px !important;
}

.news-date {
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  text-transform: capitalize;

  /* Primary 3 */

  color: #3c4645;

  opacity: 0.5;
  padding-top: 10px;
  padding-bottom: 10px;
}

.button-padding {
  padding-left: 30px;
  padding-right: 30px;
}

.padding-50 {
  padding: 50px;

}

.modal-popup-content p {
  border: none;

}

.button-white {
  border: 1px solid #f49400;
  border-radius: 100px;
  margin-left: 30px;
}

textarea {
  margin: auto;
}
</style>
